module.exports = "../images/cabin-4-person-1@2x.jpg?v=80ced63";